import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('billing');

export class Receipt extends Api {
  constructor(http, config = {}) {
    super(http, url, 'receipt', config);
  }
}
